module.exports = __webpack_public_path__ + "cc149190e3c4f2b8c929ec2eaa3772a3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-12.png
// module id = 2963
// module chunks = 0